import { SocialDashboard } from '@/components/social'
import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export function SocialTab() {
  const [searchParams, setSearchParams] = useSearchParams()
  const requestedConnectionId = searchParams.get('conversation')

  const setConnection = useCallback(
    (connectionId: string | null) => {
      if (searchParams.get('conversation') === connectionId)
        return
      const nextParams = new URLSearchParams(searchParams)
      nextParams.set('tab', 'social')
      if (connectionId)
        nextParams.set('conversation', connectionId)
      else nextParams.delete('conversation')
      setSearchParams(nextParams, { replace: true })
    },
    [searchParams, setSearchParams],
  )

  return (
    <SocialDashboard
      requestedConnectionId={requestedConnectionId}
      onConnectionChange={setConnection}
    />
  )
}
